import React from "react";
import { Typography } from "@mui/material";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  KeyboardSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  sortableKeyboardCoordinates,
} from "@dnd-kit/sortable";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import WitnessItem from "./WitnessItem";

const WitnessReorderList = ({ witnesses, onDragEnd }) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 8 },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  if (witnesses.length === 0) {
    return (
      <Typography
        variant="body2"
        sx={{ textAlign: "center", color: "text.disabled", py: 3 }}
      >
        Esta nota no tiene testigos registrados.
      </Typography>
    );
  }

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={onDragEnd}
      modifiers={[restrictToVerticalAxis]}
    >
      <SortableContext
        items={witnesses.map((w) => String(w.witness_id))}
        strategy={verticalListSortingStrategy}
      >
        {witnesses.map((witness) => (
          <WitnessItem
            key={witness.witness_id}
            witness={witness}
          />
          
        ))}
      </SortableContext>
    </DndContext>
  );
};

export default WitnessReorderList;
